import { theme } from "kosmos-ui/lib";
import styled from "styled-components";

export const RecommendationsContainer = styled.section`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colorsPalette.black.darker};
  padding: 72px;

  @media (max-width: 600px) {
    padding: 40px 24px;
  }
`;

export const RecommendationContainer = styled.div`
  margin: auto;
  max-width: 1200px;
  width: 100%;
`;

export const RecommendationsGridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(12rem, 1fr));
  gap: 16px;
  margin: 24px 0 40px 0;
`;

export const recommendationTitleStyle: React.CSSProperties = {
  color: theme.colorsPalette.white.default,
};
